import { Container, Grid, Typography, Box, Card, CardContent } from "@mui/material";
// import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';

export default function DrugPricingStats() {
  const stats = [
    {
      number: "320%",
      description: "More than what people in other countries pay for the exact same prescription drugs",
      source: "RXpose Data 2026",
      bgColor: "#FEEDED",
      textColor: "#BD2727"
    },
    {
      number: "80%",
      description: "Insulin costs significantly more in America than in the rest of the world",
      source: "RXpose Data 2026",
      bgColor: "#E6F0FE",
      textColor: "#2771D9"
    },
    {
      number: "3x",
      description: "Americans are nearly 3 times more likely to skip medications due to cost than Canadians",
      source: "Commonwealth Fund, 2022",
      bgColor: "#F8F1FF",
      textColor: "#8D42D8"
    },
    {
      number: "4x",
      description: "U.S. brand-name drug prices are 3-4 times higher than in the U.K.",
      source: "KFF & Health Affairs, 2022",
      bgColor: "#FCF1E7",
      textColor: "#DD802C"
    }
  ];

  return (
    <Box 
      className="drug_pricing_section_main" 
      sx={{ 
        py: 8, 
       
      }}
    >
      <Container>
        <Box textAlign="center" mb={6}>
          <Typography 
            variant="h2" 
            className="heading_two" 
            gutterBottom
            sx={{ 
              fontSize: "36px",
              fontWeight: 900,
              color: "#000000",
              lineHeight: "48px",
              mb: 5
            }}
          >
            The Hard Truth About Drug Pricing
          </Typography>
        </Box>

        <Grid container spacing={4}>
          {stats.map((stat, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Card 
                elevation={0}
                sx={{ 
                  backgroundColor: stat.bgColor,
                  height: "100%",
                  p: 3,
                  
                }}
              >
                <CardContent sx={{ p: 0, "&:last-child": { pb: 0 } }}>
                  <Box display="flex" alignItems="center" mb={2.5}>
                    <Typography 
                      variant="h3" 
                      sx={{ 
                        color: stat.textColor,
                        fontWeight: 700,
                        fontSize: { xs: "2rem", md: "3rem" },
                        mr: 1.1,
                        lineHeight: 1
                      }}
                    >
                      {stat.number}
                    </Typography>
                    <ArrowOutwardIcon 
                      sx={{ 
                        color: stat.textColor,
                        fontSize: { xs: "1.5rem", md: "2rem" }
                      }} 
                    />
                  </Box>
                  
                  <Typography 
                    variant="body1" 
                    sx={{ 
                      color: "#000000",
                      fontSize: "18px",
                      lineHeight: 1.6,
                      mb: 2.5,
                      minHeight: { xs: "70px", md: "80px" }
                    }}
                  >
                    {stat.description}
                  </Typography>
                  
                  <Typography 
                    variant="caption" 
                    sx={{ 
                      color: "#000000",
                      fontStyle: "italic",
                      fontSize: "16px",
                      display: "block"
                    }}
                  >
                    {stat.source}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}